import { CloudDownloadIcon, Popover } from "@codat/orchard-ui";
import React, { useRef, useState } from "react";

import Button from "components/Button";
import { useExportModalState } from "components/CompanyHeader/hooks/useExportModalState";

import { ExportDataModal } from "../ExportDataModal/ExportDataModal";
import styles from "./ExportDataButton.module.css";

export interface ExportDataButtonProps {
  companyId: string;
  companyName: string;
  loading: boolean;
}

const ExportDataButton: React.FC<ExportDataButtonProps> = ({
  companyId,
  companyName,
  loading,
}) => {
  const exportButtonRef = useRef(null);
  const [showExportModal, setShowExportModal] = useState(false);

  const {
    metadata,
    metadataLoading,
    isGeneratingReport,
    generateNewReport,
    handleExcelFileDownload,
  } = useExportModalState(companyName || "", companyId);

  return (
    <Popover
      onClose={() => setShowExportModal(false)}
      isOpen={showExportModal}
      placement="bottom"
      shadowDepth="800"
      disableScale
      removePadding
      popoverClassName={styles.exportModalPopper}
      content={
        <ExportDataModal
          companyId={companyId}
          metadata={metadata}
          metadataLoading={metadataLoading}
          isGeneratingReport={isGeneratingReport}
          generateNewReport={generateNewReport}
          handleExcelFileDownload={handleExcelFileDownload}
        />
      }
    >
      <Button
        variant="secondary"
        color="interface"
        buttonName="Export data"
        eventProperties={{ companyId }}
        data-testid="export-data-button"
        ref={exportButtonRef}
        onClick={() => setShowExportModal(!showExportModal)}
        isSkeleton={loading}
      >
        <CloudDownloadIcon className={styles.icon} />
        <span>Export data</span>
      </Button>
    </Popover>
  );
};

export default ExportDataButton;
